import { PrescriptionAndUnHandledOrdersContext } from 'Context';
import { useContext } from 'react';

export const usePrescriptionAndUnHandledOrders = () => {
  return useContext(PrescriptionAndUnHandledOrdersContext);
};
